// extracted by mini-css-extract-plugin
export default {"dark":"WarningAdminModal_dark__gEr+9","App":"WarningAdminModal_App__953L0","wrapper":"WarningAdminModal_wrapper__uWqCz"};